(() => {
  document.querySelectorAll('[data-compare]').forEach((compare) => {
    const input = compare.querySelector('.compare-input');
    if (!input) return;
    const update = () => compare.style.setProperty('--compare', `${input.value}%`);
    input.addEventListener('input', update);
    update();
  });

  const menuButton = document.querySelector('.menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
    mobileNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      mobileNav.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }));
  }

  const serviceSelect = document.getElementById('service-select');
  document.querySelectorAll('[data-service]').forEach((link) => {
    link.addEventListener('click', () => {
      if (serviceSelect) serviceSelect.value = link.dataset.service || '';
    });
  });

  const year = document.getElementById('year');
  if (year) year.textContent = String(new Date().getFullYear());

  const previewPrivacyLink = document.querySelector('#demo-contact-form .consent a');
  if (previewPrivacyLink) previewPrivacyLink.href = '/datenschutz.html';

  const demoForm = document.getElementById('demo-contact-form');
  const demoNotice = document.getElementById('form-notice');
  if (demoForm && demoNotice) {
    demoForm.addEventListener('submit', (event) => {
      event.preventDefault();
      demoNotice.textContent = 'Die Angaben wurden hier nicht versendet. Nutzen Sie bitte den E-Mail-Link zu oskom@outlook.de im Kontaktbereich. Für Formularanfragen muss das Shopify-Theme installiert und die Empfängeradresse in Shopify konfiguriert sein.';
      demoNotice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
